const FLOORMAP_ADD_ROOM_RESOURCE_DIALOG = 'FLOORMAP_ADD_ROOM_RESOURCE_DIALOG';

export default {
  FLOORMAP_ADD_ROOM_RESOURCE_DIALOG
};
